import type { InterventionAssignOptions } from "./intervention-assign.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";
import type { QueryInvalidateTarget } from "@/services/query";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

export const useInterventionAssign = (
  interventionId: number,
  options?: InterventionAssignOptions
) => {
  const defaultInvalidate: QueryInvalidateTarget[] = [
    ["interventions", "list"],
    ["interventions", "get", interventionId],
  ];

  const onSuccess = useMutationOnSuccess({ ...options, defaultInvalidate });

  const mutationFn = (users: number[]) => {
    return client.interventions.assign(interventionId, users);
  };

  return useMutation<ApiEmptyResponse, ApiError, number[]>({
    mutationFn,
    onSuccess,
  });
};
